import React from 'react';
import './Costmetic.css';
import appImage from '../../../imgs/IBM-Applicat.webp'; 

const Costmetic = () => {
  return (
    <div className="costma-wrapper">
      <h2>APPLICATIONS</h2>
      <p className="more-apps">More Applications</p>
      <div className="costma-card"data-aos="fade-down" >
        <img src={appImage} alt="Application" className="costma-img" />
      </div>
    </div>
  );
};

export default Costmetic;
